module.exports = __webpack_public_path__ + "img/texto_diresa-pagina-2.a85db4ee.svg";